"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_NAME = exports.LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_KEY = void 0;
exports.LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_KEY = "LinkCustomerToTargetSubsidiary";
exports.LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_NAME = "Link Customer to Target Subsidiary";
